/* CSS */
import styles from './PasswordChecklist.module.css';

/* Icons */
import tick_icon_white from '../../assets/icons/tick_icon_white.svg';

const PasswordChecklist = ({ criteria, isConfirmPassword = false, showErrors = false }) => {

    // Helper to figure out the text color
    const getTextColor = (isValid) => {
        if (isValid) return styles.textValid;
        if (!isValid && showErrors) return styles.textError;
        return '';
    };

    // Helper to figure out the icon style
    const getIconStyle = (isValid) => {
        if (isValid) return styles.validIcon;
        return styles.invalidIcon;
    };

    if (isConfirmPassword) {
        return (
            <div className={styles.criteriaList}>
                <div className={`${styles.criteriaItem} ${getTextColor(criteria.match)}`}>
                    <img src={tick_icon_white} className={getIconStyle(criteria.match)} />
                    <span>Must match with new password</span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.criteriaList} style={{ marginBottom: '24px' }}>
            <div className={`${styles.criteriaItem} ${getTextColor(criteria.length)}`}>
                <img src={tick_icon_white} className={getIconStyle(criteria.length)} />
                <span>Between <strong>8-16</strong> characters</span>
            </div>
            <div className={`${styles.criteriaItem} ${getTextColor(criteria.uppercase)}`}>
                <img src={tick_icon_white} className={getIconStyle(criteria.uppercase)} />
                <span>At least one <strong>uppercase</strong> character</span>
            </div>
            <div className={`${styles.criteriaItem} ${getTextColor(criteria.number)}`}>
                <img src={tick_icon_white} className={getIconStyle(criteria.number)} />
                <span>At least one <strong>number</strong></span>
            </div>
            <div className={`${styles.criteriaItem} ${getTextColor(criteria.special)}`}>
                <img src={tick_icon_white} className={getIconStyle(criteria.special)} />
                <span>At least one <strong>special</strong> character</span>
            </div>
        </div>
    );
};

export default PasswordChecklist;
